import { useEffect, useRef, useState } from "react";
import { _no } from "../utils";

import { useFarmingContext } from "../screens/Farming/context";

const COLORS = {
    green: "#B5E4CA",
    yellow: "#FBB54B",
    red: "#FF6A55"
};

export const useOpenFarmsAverageAPY = ({
    data
}) => {
    const farmingContext = useFarmingContext();
    const [averageAPY, setAverageAPY] = useState(null);
    const { farmAPYs } = farmingContext;
    const timeoutRef = useRef(null);

    const farmsWithOpenPositions = data
        ?.filter(farm => farm.hasNFT)
        ?.map(farm => ({
            poolName: farm.poolName
        }));

    const fetchAverageAPY = async () => {
        if (_no(farmsWithOpenPositions) || _no(Array.isArray(farmsWithOpenPositions))) {
            return null;
        }

        if (farmsWithOpenPositions.length === 0) {
            return {
                value: 0,
                color: COLORS.green
            };
        }

        if (_no(farmAPYs)) {
            return null;
        }

        const validFarms = farmsWithOpenPositions
            .filter(farm => farmAPYs[farm.poolName]);

        if (validFarms.length !== farmsWithOpenPositions.length) {
            return null;
        }

        let hasNegativeFarm = false;
        let totalFarmAPY = 0;

        for (const farm of validFarms) {
            const apy = Number(farmAPYs[farm.poolName]);
            if (apy < 0) {
                hasNegativeFarm = true;
            }
            totalFarmAPY += apy;
        }

        const average = totalFarmAPY / validFarms.length;

        let color;
        if (average < 0) {
            color = COLORS.red;
        } else if (hasNegativeFarm) {
            color = COLORS.yellow;
        } else {
            color = COLORS.green;
        }

        return {
            value: average,
            color
        };
    };

    useEffect(() => {
        setAverageAPY(null);

        const executeFetch = async () => {
            const result = await fetchAverageAPY();
            setAverageAPY(result);
        };

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(
            executeFetch,
            1000
        );

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(farmsWithOpenPositions), farmAPYs]);

    return averageAPY;
};
